<script lang="ts">
  import { applicationRoleLabel } from '../utils/roleLabels';
  import { user } from '../stores/user';
  import { exitImpersonation, reloadIdentity, clearImpersonation } from '../utils/impersonation';
  let busy = $state(false);
  let error = $state('');
  $effect(() => {
    const expires = $user?.impersonation?.expires_at;
    if (!expires) return;
    const remaining = Date.parse(expires) - Date.now();
    if (!Number.isFinite(remaining)) return;
    const timer = setTimeout(() => {
      clearImpersonation();
      sessionStorage.setItem('saya.impersonationEnded', 'true');
      reloadIdentity('/admin/users');
    }, Math.max(0, Math.min(remaining, 2_147_483_647)));
    return () => clearTimeout(timer);
  });
  async function exit() {
    busy = true; error = '';
    try { await exitImpersonation(); reloadIdentity('/admin/users'); }
    catch (e) { error = e instanceof Error ? e.message : 'Unable to exit.'; busy = false; }
  }
</script>
{#if $user?.impersonation}
  <div class="bg-warning text-warning-content px-4 py-3 flex flex-wrap items-center justify-between gap-3" role="region" aria-label="Impersonation">
    <div>
      <p class="font-semibold">Acting as {$user.name || `User ${$user.user_id}`} — changes are live</p>
      <p class="text-xs">{applicationRoleLabel($user.user_type)} · Ends {new Date($user.impersonation.expires_at).toLocaleTimeString()}</p>
      {#if error}<p role="alert">{error}</p>{/if}
    </div>
    <button class="btn btn-sm" disabled={busy} onclick={exit}>{busy ? 'Exiting…' : 'Exit impersonation'}</button>
  </div>
{/if}
